import { useNavigate } from 'react-router-dom';
import AppHeader from '@/components/layout/AppHeader';
import { empresaOptions, useEmpresaStore } from '@/store/empresaStore';
import styles from '@/styles/ui.module.css';

export default function EmpresaSelectionPage() {
  const navigate = useNavigate();
  const setEmpresa = useEmpresaStore((state) => state.setEmpresa);

  const handleSelection = (empresaId: number) => {
    const empresa = empresaOptions.find((item) => item.id === empresaId) ?? null;
    setEmpresa(empresa);
    navigate('/clientes');
  };

  return (
    <div className={styles.page}>
      <AppHeader
        title="Selecciona la empresa"
        subtitle="Decide con que compania quieres operar hoy"
        showBack={false}
      />
      <div className={styles.screenWrapper}>
        <div className={styles.orderList}>
          {empresaOptions.map((empresa) => (
            <button
              key={empresa.id}
              type="button"
              className={styles.empresaPill}
              onClick={() => handleSelection(empresa.id)}
            >
              <div className={styles.empresaCardHeader}>
                <div>
                  <p className={styles.clientTitle}>{empresa.nombre}</p>
                </div>
                <span className={`${styles.orderBadge} ${styles.orderBadgeBlue} ${styles.companyBadge}`}>
                  Empresa {empresa.id}
                </span>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
